import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../ui/button';

const CTASection = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Ready to Grade Your Cards?
          </h2>
          {/* IMPROVED: Changed from #B2B4B2 to text-gray-600 for better contrast */}
          <p className="text-lg text-gray-600 mb-8">
            Join thousands of collectors who trust NICE Grading
          </p>
          <Link to="/new-submission">
            <Button className="bg-[#003594] hover:bg-[#002554] text-white px-8 py-6 text-base font-semibold rounded-md transition-all duration-200">
              Start Your Submission
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
